import { Input } from '@fluentui/react-components';
import { useOtherInfoContext } from '../OtherInfoContext';
import { isFieldReadOnly } from '../fieldReadOnly';
import { FieldWrapper } from './FieldWrapper';
import type { FieldComponentProps } from './types';

export const NumberPasswordField = ({
  field,
  fieldValue,
  isFieldDisabled,
  isSaved,
  validationMessage,
}: FieldComponentProps) => {
  const { handleOtherInfoChange, validateField } = useOtherInfoContext();

  return (
    <FieldWrapper field={field} validationMessage={validationMessage}>
      <Input
        id={field.name}
        onChange={(_, newValue) => {
          handleOtherInfoChange(field.name, newValue.value);
          validateField(field.name, newValue.value);
        }}
        type={field.fieldType === 'Number' ? 'number' : 'password'}
        min={field.fieldType === 'Number' ? field.options?.min : undefined}
        max={field.fieldType === 'Number' ? field.options?.max : undefined}
        step={field.fieldType === 'Number' ? 'any' : undefined}
        value={fieldValue == null ? '' : String(fieldValue)}
        disabled={isFieldDisabled}
        readOnly={isSaved || isFieldReadOnly(field)}
      />
    </FieldWrapper>
  );
};
